<template>
  <v-dialog
    v-model="show"
    :width="width"
    :persistent="persistent"
  >
    <v-card>
      <v-card-title>
        <h2>{{ message }}</h2>
      </v-card-title>
      <v-divider v-if="obj.infos"></v-divider>
      <v-card-text v-if="obj.infos">
        <div v-if="Array.isArray(obj.infos)" class="mb-1">
          <v-layout v-for="(value, key) in obj.infos" :key="key" row wrap>
            <v-flex xs12>{{ value }}</v-flex>
          </v-layout>
        </div>
        <div v-else>
          <v-layout v-for="(value, key) in obj.infos" :key="key" row wrap>
            <v-flex xs12 sm3><b>{{ key }} :</b></v-flex>
            <v-flex xs12 sm9>{{ value || '--' }}</v-flex>
          </v-layout>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn @click="cancelAction" color="error" :loading="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="submitAction" color="primary" :loading="loading">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    message: String,
    action: String,
    obj: [Object, null],
    show: Boolean,
    width: {
      type: Number,
      default: 500
    },
    persistent: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      loading: false
    }
  },

  methods: {
    submitAction () {
      this.loading = true
      this.$emit('submit', this.action, this.obj, () => {
        this.loading = false
      })
    },

    cancelAction () {
      this.$emit('cancel')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Common/Confirmation.vue